/**
 * 画布模式 modes - 常量定义
 */

/**
 * 模式显示名称
 */
export const MODE_DISPLAY_NAMES = {
    PROJECT: '项目预览',
    PROCEDURAL: '程序化纹理',
} as const
